import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/auth.css';

export default function PendingApproval() {
  const navigate = useNavigate();
  const { isAuthenticated, isWhitelisted, loading, logout, user, checkWhitelistStatus } = useAuth();

  useEffect(() => {
    // If whitelist status is null and we have a user, check it (AuthContext will cache)
    if (!loading && isAuthenticated && user && isWhitelisted === null) {
      // AuthContext handles caching, so this is safe to call
      checkWhitelistStatus(user.id).catch(() => {
        // Error already handled in AuthContext
      });
      return;
    }

    // If user is whitelisted, redirect to dashboard
    if (!loading && isAuthenticated && isWhitelisted === true) {
      navigate('/dashboard');
    }
    // If user is not authenticated, redirect to sign in
    if (!loading && !isAuthenticated) {
      navigate('/signin');
    }
  }, [isAuthenticated, isWhitelisted, loading, navigate, user, checkWhitelistStatus]);

  const handleLogout = async () => {
    await logout();
    navigate('/signin');
  };

  if (loading || isWhitelisted === null) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
          gap: '16px',
        }}
      >
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <section className="auth-section">
      <div className="container">
        <div className="auth-content">
          <div className="auth-header">
            <h1 className="auth-title text-gradient">
              Account Pending Review
            </h1>
          </div>

          <div style={{
            padding: '24px',
            backgroundColor: '#f8f9fa',
            borderRadius: '8px',
            marginBottom: '24px',
            textAlign: 'center',
          }}>
            <div style={{
              fontSize: '48px',
              marginBottom: '16px',
            }}>
              ⏳
            </div>
            <h2 style={{
              fontSize: '20px',
              fontWeight: '600',
              marginBottom: '12px',
              color: '#333',
            }}>
              Your registration is being reviewed
            </h2>
            <p style={{
              fontSize: '14px',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '0',
            }}>
              Our team is manually reviewing your registration. You'll be notified once your account has been approved.
            </p>
          </div>

          <div style={{
            padding: '16px',
            backgroundColor: '#fff3cd',
            border: '1px solid #ffc107',
            borderRadius: '6px',
            marginBottom: '24px',
          }}>
            <p style={{
              fontSize: '14px',
              color: '#856404',
              margin: '0',
              lineHeight: '1.5',
            }}>
              <strong>What happens next?</strong><br />
              Once approved, you'll receive an email notification and can access the dashboard immediately.
            </p>
          </div>

          <div className="auth-form-actions">
            <button
              type="button"
              className="btn btn-secondary w-full"
              onClick={handleLogout}
            >
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
